export enum ApprovalRuleEnum {
    LEAVE = 'Leave'
}
